export default "__VITE_ASSET__C7OrpzH1__"